import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import DataTable from './shared/DataTable';
import 'moment-timezone';
import { observer } from "mobx-react";

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
  },
});

class Stickers extends Component {  

  constructor(props) {
    super(props);
    this._validAuthStates = ['signedIn'];

    this.state = {
      searchTerm: ""
    }

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
  }

  componentDidMount() {
    this.props.stickerStore.getStickerList();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  componentWillUnmount() {
    clearTimeout(this.searchTimeout);
  }

  handleSearchInputChange(event) {
    this.props.stickerStore.searchTerm = event.target.value;

    /* Only search once the user stops typing */
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => this.props.stickerStore.searchSticker(), 300);
  }
  
  render() {
    const { classes } = this.props;

    return (
      <Grid container>
      <Grid item >
          <TextField
              id="searchTerm"
              name="searchTerm"
              label="Suchbegriff"
              type="search"
              className={classes.textField}
              margin="none"
              value={this.props.stickerStore.searchTerm}
              onChange={this.handleSearchInputChange} />
        </Grid>
        <DataTable 
          store={this.props.stickerStore} 
          rows={this.props.stickerStore.stickerList} 
          columns={this.props.stickerStore.tableColumns}
          history={this.props.history}
        />
      </Grid>
    );
  }
}

export default withStyles(styles)(observer(Stickers));
